<template>
  <TheModal
    :is-open="isShowFormSuccessPopUp"
    :mask-closable="false"
    max-width="480px"
    min-height="100px"
  >
    <div class="p-6 tablet:px-0 tablet:py-2">
      <strong class="block text-2xl">
        {{ $t('form.submit-success.title') }}
      </strong>
      <p class="mt-2 text-sm text-gray-600">
        {{ $t('form.submit-success.description') }}
      </p>
      <div class="mt-6 flex justify-end">
        <TheButton
          class="w-full tablet:w-[120px]"
          :title="$t('form.confirm')"
          @click="handleReload"
        >
          <span class="text-sm">{{ $t('form.confirm') }}</span>
        </TheButton>
      </div>
    </div>
  </TheModal>
</template>

<script setup lang="ts">
  const mainStore = useMainStore();
  const { isShowFormSuccessPopUp } = storeToRefs(mainStore);

  const handleReload = (): void => {
    window.location.reload();
  };
</script>
